// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wUNV","field":"styles_field__KHB6G","fieldCol":"styles_fieldCol__21geD","diffCol":"styles_diffCol__Sx2Rn","diff":"styles_diff__193X1"};